import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnInit,
} from '@angular/core';
import {
    DataService,
    SharedModule,
    TypedBaseDetailComponent,
} from '@vendure/admin-ui/core';
import { UntypedFormGroup } from '@angular/forms';
import { CustomerValidationDocument } from '../../generated/customer-validation/graphql';

@Component({
    selector: 'customer-validation',
    templateUrl: './customer-validation.component.html',
    styleUrls: ['./customer-validation.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [SharedModule],
})
export class CustomerValidationComponent
    extends TypedBaseDetailComponent<
        typeof CustomerValidationDocument,
        'customer'
    >
    implements OnInit
{
    isAccountOkay = true;
    errors: { type: string; message: string }[] = [];
    constructor(
        protected dataService: DataService,
        private cdr: ChangeDetectorRef
    ) {
        super();
    }

    detailForm: UntypedFormGroup;

    // sem form, só exibe dados
    protected setFormValues(): void {}

    ngOnInit() {
        const id = this.route.snapshot.params['id'];

        this.dataService
            .query(CustomerValidationDocument, { id })
            .single$.subscribe(({ customer }) => {
                if (customer?.normalizeAccountStatus) {
                    this.isAccountOkay =
                        customer.normalizeAccountStatus.isAccountOkay;
                    // garante array novo + remove nulls
                    this.errors = (customer.normalizeAccountStatus.errors ?? [])
                        .filter(
                            (e): e is { type: string; message: string } => !!e
                        )
                        .map((e) => ({ type: e.type, message: e.message }));
                    this.cdr.markForCheck(); // força refresh no OnPush
                }
            });
    }
}
